<script setup>

import {convertPriorityToColor, HospitalTypeLabel, StartTriageColorLabel} from "../../choices";
import {getRemainingTimeMessage} from "./td/utils";
import {computed} from "vue";
import {pgettext} from "../../../../utils/translate";
import {GenderLabel, YesNo, YesNoLabels} from "../../../../choices";
import {unitType, ventilated} from "../../utils";
import {useDisplay} from "vuetify";
import {mdiGestureTap} from "@mdi/js";

const props = defineProps({
  patient: {
    type: Object,
    required: true
  },
  now: {
    type: Object,
    required: true
  }
})

const {smAndDown} = useDisplay()
const emit = defineEmits(['displayActionsModal'])

const color = computed(() => {
  return convertPriorityToColor(props.patient.transportPriority).toLowerCase()
})



function displayActionsModal() {
  emit('displayActionsModal', props.patient)
}


</script>

<template>
  <v-alert border="start" :color="color" class="mb-1">
    <template #title>
      <div class="d-flex flex-wrap font-weight-bold mb-2">
        <div>{{ patient.tic }}</div>
      </div>
    </template>
    <v-row no-gutters>
      <v-col cols="12" md="4">
        <dl>
          <dt>{{ pgettext('label', 'Temporary Identifier') }}</dt>
          <dd>{{ patient.temporaryIdentifier }}</dd>
          <dt>{{ pgettext('label', 'Last Name') }}</dt>
          <dd>{{ patient.lastName }}</dd>
          <dt>{{ pgettext('label', 'First Name') }}</dt>
          <dd>{{ patient.firstName }}</dd>

          <dt>{{ pgettext('label', 'Birth Number') }}</dt>
          <dd>{{ patient.birthNumber }}</dd>
          <dt>{{ pgettext('label', 'Insurance') }}</dt>
          <dd>{{ patient.insurance }}</dd>


          <dt>{{ pgettext('label', 'Gender') }}:</dt>
          <dd>{{ GenderLabel[patient.gender] }}</dd>
          <dt>{{ pgettext('label', 'Child') }}:</dt>
          <dd>
            <strong class="text-red">
              <template v-if="patient.isChild === true">{{ YesNoLabels[YesNo.YES] }}</template>
              <template v-else>{{ YesNoLabels[YesNo.YES] }}</template>
            </strong>
          </dd>
          <dt>{{ pgettext('label', 'TIC Card Number') }}:</dt>
          <dd>{{ patient.tic }}</dd>

          <template v-if="smAndDown">


          </template>
        </dl>
      </v-col>
      <v-col v-if="!smAndDown" cols="12" md="4">
        <dl>

        </dl>
      </v-col>
      <v-col cols="12" md="4">
        <dl>

        </dl>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-btn class="text-wrap w-auto"
               block
               :prepend-icon="mdiGestureTap"
               @click="displayActionsModal">
          <span class="text-wrap">{{ pgettext('label', 'Options') }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>